import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Chip from "@material-ui/core/Chip";

const styles = theme => ({

  root: {
    width: "100%",
    maxWidth: 850,
    height: 90,
    margin: "14px auto",
    borderRadius: 24,
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.15)",
    cursor: "pointer",
    transition: "all 0.2s ease",

    "&:hover": {
      transform: "scale(1.01)",
      boxShadow: "0px 12px 28px rgba(0, 0, 0, 0.2)"
    },

    [theme.breakpoints.up("lg")]: {
      height: 110,
      maxWidth: 1000,
    }
  },

  left: {
    width: 140,
    height: "100%",
    backgroundColor: "#0F6B5B",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  turmaText: {
    color: "#FFFFFF",
    fontWeight: 700,
    fontSize: 24,

    [theme.breakpoints.up("lg")]: {
      fontSize: 30,
    }
  },

  center: {
    flex: 1,
    backgroundColor: "#E5E5E5",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },

  numero: {
    color: "#18A689",
    fontWeight: 700,
    fontSize: 32,
    lineHeight: 1,

    [theme.breakpoints.up("lg")]: {
      fontSize: 40,
    }
  },

  label: {
    color: "#18A689",
    fontWeight: 600,
    fontSize: 14,
  },

  right: {
    backgroundColor: "#E5E5E5",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    paddingRight: theme.spacing(3),
    gap: theme.spacing(1),
  },

  chipAusente: {
    border: "1px solid #C70707",
    color: "#C70707",
    backgroundColor: "transparent",
    fontWeight: 600,
    fontSize: 12,
  },

  chipRestricao: {
    border: "1px solid #B78809",
    color: "#B78809",
    backgroundColor: "transparent",
    fontWeight: 600,
    fontSize: 12,
  }

});

class TurmaCard extends React.Component {

  render() {

    const {
      classes,
      turma,
      presentes,
      ausentes,
      restricoes,
      onClick
    } = this.props;

    return (
      <Paper elevation={0} className={classes.root} onClick={onClick}>

        {/* ESQUERDA */}
        <div className={classes.left}>
          <Typography className={classes.turmaText}>
            {turma}
          </Typography>
        </div>

        {/* CENTRO */}
        <div className={classes.center}>
          <Typography className={classes.numero}>
            {presentes}
          </Typography>
          <Typography className={classes.label}>
            Presentes
          </Typography>
        </div>

        {/* DIREITA */}
        <div className={classes.right}>

          {ausentes > 0 && (
            <Chip
              label={`${ausentes} ausentes`}
              className={classes.chipAusente}
              size="small"
            />
          )}

          {restricoes > 0 && (
            <Chip
              label={`${restricoes} restrições`}
              className={classes.chipRestricao}
              size="small"
            />
          )}

        </div>

      </Paper>
    );
  }
}

TurmaCard.propTypes = {
  turma: PropTypes.string.isRequired,
  presentes: PropTypes.number.isRequired,
  ausentes: PropTypes.number,
  restricoes: PropTypes.number,
  onClick: PropTypes.func
};

export default withStyles(styles)(TurmaCard);